import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '@tymely/components/Icons/Logo';

import NavItemButton from './NavItemButton';
import NavItem from './NavItem';

const LogoItem = memo(() => {
    const navigate = useNavigate();
    return (
        <NavItem sx={{ mb: 3.5 }}>
            <NavItemButton onClick={() => navigate('/ticket')}>
                <Logo />
            </NavItemButton>
        </NavItem>
    );
});

LogoItem.displayName = 'LogoItem';
export default LogoItem;
